
import {useState} from 'react'
import {AiOutlineMail} from 'react-icons/ai'
import {IoMdCall} from 'react-icons/io'
import {IoLocationOutline} from 'react-icons/io5'

import { address, base_url, department, email, mobile } from '../constant/Appconstants'
import ErrorComponent from '../constant/ErrorComponent'
import axios from 'axios'
import {message} from 'antd'
import Typist from 'react-typist'

function Contact() {

  const [data,setdata] = useState({name:'',email:'',requirment:'',department_website:''})
  const [error,seterror] = useState({name:'',email:'',requirment:'',department_website:''})

  function handleChange(e){
    setdata({...data,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  } 

  async function submitForm(){
    if(!data?.name){
      seterror({...error,name:'This Field is required *'})
    }else if(!data?.email){
      seterror({...error,email:'This Field is required *'})
    }else if(!data?.requirment){
      seterror({...error,requirment:'This Field is required *'})
    }else{
     
      const sendData = {...data}
      sendData['department_website'] = department
      
      await axios.post(`${base_url}clients/create`,sendData)
      .then((res)=>{
        if(res?.status === 201){
          message.success('Form Submitted Successfully')
          setdata({name:'',email:'',requirment:'',department_website:''})
          seterror({name:'',email:'',requirment:'',department_website:''})
        }
      }).catch((err)=>{      
      }) 
    }
  }

  return (
    <div className="w-full h-full overflow-x-hidden bg-white">
        <div className='h-[130px]  relative md:min-h-[240px] 2xl:min-h-[500px] bg-cover md:bg-cover bg-no-repeat w-full bg-contact_bg'>
            <div className='border-l w-[75%] md:w-[35%] border-l-4  border-l-[#4190ac] ml-[6%] pl-[1.5%] absolute top-[15%]'>
            {/* <Typist avgTypingDelay={15} stdTypingDelay={15}> */}
                <h6 className='text-[19px] md:text-[21px] 2xl:text-[24px] text-[#fff] font_thicker font-[800]  '>Get In Touch</h6>
                <h6 className='text-[13px] md:text-[14px] 2xl:text-[17px] text-[#fff] font_normal'>We’re here to support your facility management needs. Reach out to us for reliable and 
                efficient solutions.</h6>
            {/* </Typist>     */}
            </div>
        </div>
      {/* <div className='h-[250px] w-screen overflow-hidden relative md:h-[400px] grid place-items-center  bg-[#f7f3ef]  '>
      
       <div >
        <h1 className='text-center text-[40px]'>Contact us</h1>

        <h6 className='text-center tracking-wider text-black-400 text-[14px]'> <span className='cursor-pointer'>Home</span> / Contact us</h6>
        <h6 className='text-center tracking-wider text-black-400 text-[12px]'>24/7 We are ready to assist you!</h6>
        </div>

        <img src={GLobe} className="absolute -right-[35vw]  animate-rotate-full   h-[250px]  md:h-[400px] object-contain " />
        <img src={User} className="absolute -right-[28%] md:right-0 top-10   h-[250px]  md:h-[400px] object-contain " />

      </div> */}

        <div className='pt-10 md:pt-0'>
        <div className='w-[80vw] mx-auto md:py-20'>
       

        <div>

           
           <div className='flex-row-reverse md:flex-row md:flex '>
              <div data-aos="fade-up" className='md:mt-10 md:w-[48%]'>
                  <h6 className='ml-1 text-[26px] 2xl:text-[29px] font_thicker w-[100%] md:w-[70%]'>Let’s discuss how we can support your business. <span> 👋</span>.</h6>

                  <h6 className=' mt-5 text-gray-600 w-[100%] font_normal  mx-auto text-[14px] 2xl:text-[17px]'>Reach out to us for seamless facility management solutions that cater to your specific needs. Our team is ready to assist you.</h6>
                
                  <div className='w-full mt-5'>
                    <h6 className='mb-1 text-[13px] 2xl:text-[16px] 2xl:text-[16px] font_normal'>Name</h6>
                    <input type='text' name="name" value={data?.name} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
                  </div>

                  <ErrorComponent error={error?.name} />

                
                  <div className='w-full mt-2'>
                    <h6 className='mb-1 text-[13px] 2xl:text-[16px] font_normal'>Email</h6>
                    <input type='text' name="email" value={data?.email} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
                  </div>
                  <ErrorComponent error={error?.email} />


                  <div className='w-full mt-2'>
                    <h6 className='mb-1 text-[13px] 2xl:text-[16px] font_normal'>Message</h6>
                    <textarea type='text' name="requirment" value={data?.requirment} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
                  </div>
                  <ErrorComponent error={error?.requirment} />
                

                  <button onClick={submitForm} className='text-[12px] 2xl:text-[15px] font_normal flex mt-2 items-end justify-end bg-black text-white p-2'>
                    SUBMIT
                  </button>

              </div>

              <div data-aos="fade-up" className='md:ml-[4%] md:w-[48%] mt-10'>
                <div className='w-[100%]'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.201402509898!2d77.5725512!3d12.9205498!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14293cbbedf9%3A0x4f12794ce5a209a4!2sFidelitus%20Corp!5e0!3m2!1sen!2sin!4v1691664501989!5m2!1sen!2sin" className='w-full' height="400"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
           </div>


          

        </div>
        


       










      
        </div>
        </div>

        <div className='w-[100%] bg-gray-100 mt-[5%] mx-auto py-20'> 
          <h6 className='text-[12px] w-[80%] md:w-full mx-auto text-center mb-2 text-gray-400 tracking-wider uppercase'>Visit US</h6>
          <h6 className='text-[28px] md:text-[32px] text-center mx-5 md:mx-0 md:w-[100%] font_thicker mx-auto '>Visit our  <span className='text-[#4190ac]'>Main Branch</span> office mentioned below for direct interaction.</h6>


          <h6 className='text-[14px] font-[400] text-center font_normal text-slate-500 pt-4'>HEAD OFFICE</h6>

          <div className='flex md:w-[75%] mt-10  mx-auto'>

          <div className='h-full md:flex'>


            <div data-aos="fade-right" className='flex items-center w-full px-5 pl-4 pr-4 mt-4 border-gray-300 md:justify-center md:border-r'>
            <IoLocationOutline color='#4190ac' size={60} />
            <h6 className='text-[14px] font_normal cursor-pointer pl-3'>{address}</h6>
            </div>

            <div data-aos="fade-up" data-aos-delay="400" className='flex items-center w-full px-5 pl-4 pr-4 mt-4 border-gray-300 md:justify-center md:border-r'>
            <IoMdCall color='#4190ac' size={15} />
            <h6 className='text-[14px] font_normal  cursor-pointer  pl-2'>{mobile}</h6>
            </div>

            <div data-aos="fade-left" className='flex items-center w-full px-5 pl-4 pr-4 mt-4 md:justify-center'>
            <AiOutlineMail color='#4190ac' size={15}/>
            <h6 className='ml-1 text-[14px] font_normal cursor-pointer  pl-2'>{email}</h6>
            </div>
          </div>

          <div>
          </div> 
          </div>
        </div>

        <h1 className=' text-center text-[17px] mt-20'>Be Part of Our <span className='text-[#4190ac] font_medium'>Growing PAN India</span>  Presence</h1>


        <div className='grid items-center justify-center grid-cols-3 px-10 mt-10 mb-20 place-self-center place-content-center md:flex'>
        <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>BANGALORE</span>
        <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>HYDERABAD</span>
        <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>CHENNAI</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>MUMBAI</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>DELHI</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>AHMEDABAD</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>KOLKATA</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>PUNE</span>
        <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>KOCHI</span>

        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>SALEM</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>GURGAON</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>MANAGALORE</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>HASAN</span>
        <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>KALBURGI</span>

        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>KERALA</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>HAMPI</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>HOSPET</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>TUMAKUR</span>
        <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>CHIKKAMAGALORE</span>
        <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>SHIVAMOGGA</span>

        
      </div>

        {/* <div className='bg-[#f7f3ef] px-[10vw] py-20 md:flex justify-between'>
            <h6 className='font_thicker font-[500] text-[30px] md:w-[70%]'>We provide all kinds of IT & Non IT Candidates that vow your organization <span className='text-[#4190ac]'>success</span></h6>


            <button className='mt-10 md:mt-0'>
              
              <Link href={`tel:${mobile}`} target='_blank'>
              <div className='flex items-center bg-[#000] text-white rounded p-3 transition duration-300 ease-in hover:-translate-y-1 '>
                <BsChatLeftDots />
                <h6 className='ml-3'>Let&apos;s Talk</h6>
              </div>
              </Link>
            </button>


        </div> */}
    </div>
  )
}

export default Contact